import axios from 'axios';

export const state = {
  financialProducts: [],
  loading: false,
};

export const mutations = {
  setFinancialProducts(context, financialProducts) {
    context.financialProducts = financialProducts;
    context.loading = false;
  },

  setLoading(context, value) {
    context.loading = value;
  },
};

export const actions = {
  async getFinancialProducts({ commit, rootState }, query) {
    try {
      const { jwtToken } = rootState.userStore.user.signInUserSession.idToken;
      const options = {
        headers: {
          Authorization: jwtToken,
        },
      };
      commit('setLoading', true);
      const financialProducts = await axios.get(`${window.BASE_API.FINANCIAL_PRODUCT}/financial-products?${query}`, options)
        .then(response => response);

      commit('setFinancialProducts', financialProducts.data);
      commit('setLoading', false);
    } catch (err) {
      commit('setLoading', false);
    }
  },
  async getFinancialProduct(context, query) {
    return axios
      .get(`${window.BASE_API.FINANCIAL_PRODUCT}/financial-products?${query}`)
      .then(response => response.data);
  },
  async checkMangoPayUserIdValidity({ rootState }, userId) {
    try {
      const { jwtToken } = rootState.userStore.user.signInUserSession.idToken;
      const options = {
        headers: {
          Authorization: jwtToken,
        },
      };
      const response = await axios.get(`${window.BASE_API.EMONEY}/admin/mangopay-user/${userId}`, options);

      return response.data.valid;
    } catch (error) {
      console.error('Error checking Mango pay user ID validity:', error);

      return false;
    }
  },
  async checkMangoPayWalletValidity({ rootState }, walletId) {
    try {
      const { jwtToken } = rootState.userStore.user.signInUserSession.idToken;
      const options = {
        headers: {
          Authorization: jwtToken,
        },
      };
      const response = await axios.get(`${window.BASE_API.EMONEY}/admin/wallet/${walletId}`, options);

      return response.data.valid;
    } catch (error) {
      console.error('Error checking Mango Pay wallet validity:', error);

      return false;
    }
  },

  async updateFinancialProduct(context, financialProduct) {
    return axios.put(`${window.BASE_API.FINANCIAL_PRODUCT}/financial-products`, financialProduct)
      .then(response => response.data);
  },
  async createDraftCall(context, data) {
    return axios
      .post(`${window.BASE_API.FINANCIAL_PRODUCT}/draft`, data)
      .catch(error => Promise.reject(error));
  },
  async createTranche(context, data) {
    return axios
      .post(`${window.BASE_API.FINANCIAL_PRODUCT}/financial-products`, data)
      .catch(error => Promise.reject(error));
  },
  async declineFP(context, data) {
    return axios
      .post(`${window.BASE_API.FINANCIAL_PRODUCT}/financial-products/decline`, data)
      .catch(error => Promise.reject(error));
  },
};

const financialProductsStore = {
  state,
  mutations,
  actions,
};

export default financialProductsStore;



// WEBPACK FOOTER //
// ./src/store/financialProducts/financialProductsStore.js